<template>
  <main class="main">
    <div class="anim-wrap">
      <div class="container">

        <div class="row page-nav">
          <div class="col-md-8 hidden-sm">
            <nav class="breadcrumbs">
              <ol class="breadcrumb">
                <li>
                  <router-link to="/" class="link-item">Dashboard</router-link>
                </li>
                <li><span class="link-item">Knowledge base</span></li>
              </ol>
            </nav>
          </div>
          <div class="col-md-4 text-md-right">
            <router-link to="/" class="link-item"
              ><font-awesome-icon icon="angle-left" /> Back to
              Dashboard</router-link
            >
          </div>
        </div>

        <div class="row">
          <div class="col-12 mb-5">
            <h1>Knowledge Base</h1>
            <h4 class="color-grey">Assets and information</h4>
          </div>
        </div>

        <div class="row">
          <div
            class="col-md-4"
            v-bind:key="key"
            v-for="(persona, key) in personas"
          >
            <PersonalityUserCard :personality="{ persona: key }" :link="true" />
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import { personas } from "@/assets/static.js";
import PersonalityUserCard from "@/components/PersonalityUserCard";

export default {
  name: "KnowledgeBase",
  components: {
    PersonalityUserCard,
  },
  computed: {},
  data() {
    return {
      personas: personas,
    };
  },
  mounted() {},
  methods: {},
};
</script>
